import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import $ from 'jquery';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin, BehaviorMapValidator } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory} from 'history';

// Import sentry error tracking
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

// Import store
import store from 'store/index';

// Import components
import App from 'containers/App';
import ScrollToTop from 'components/Common/ScrollToTop';
import notifier from 'utils/notifier';
import constants from 'constants/index';

// Import root styles
import 'assets/styles/index.scss';


const behaviorMap = {
  NAVIGATIONBACK : 1,          // Advancing to the previous index position within a webpage
  NAVIGATION : 2,              // Advancing to a specific index position within a webpage
  NAVIGATIONFORWARD : 3,       // Advancing to the next index position within a webpage
  APPLY : 4,          // Applying filter(s) or making selections
  REMOVE : 5,         // Applying filter(s) or removing selections
  SORT : 6,         // Sorting content
  EXPAND : 7,         // Expanding content or content container
  REDUCE : 8,         // Sorting content
  CONTEXTMENU : 9,             // Context Menu
  TAB : 10,                    // Tab control
  COPY : 11,                   // Copy the contents of a page
  EXPERIMENTATION : 12,        // Used to identify a third party experimentation event
  PRINT : 13,                  // User printed page
  SHOW : 14,                   //  Displaying an overlay
  HIDE : 15,                   //  Hiding an overlay
  MAXIMIZE : 16,               //  Maximizing an overlay
  MINIMIZE : 17,               // Minimizing an overlay
  BACKBUTTON : 18,             //  Clicking the back button
 
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Scenario Process [20-39]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  STARTPROCESS : 20,      // Initiate a web process unique to adopter
  PROCESSCHECKPOINT : 21,   // Represents a checkpoint in a web process unique to adopter
  COMPLETEPROCESS : 22,   // Page Actions that complete a web process unique to adopter
  SCENARIOCANCEL : 23, // Actions resulting from cancelling a process/scenario
 
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Download [40-59]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  DOWNLOADCOMMIT : 40,        // Initiating an unmeasurable off-network download
  DOWNLOAD : 41,        // Initiating a download
 
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Search [60-79]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  SEARCHAUTOCOMPLETE : 60,      // Auto-completing a search query during user input
  SEARCH : 61,            // Submitting a search query
  SEARCHINITIATE : 62,      // Initiating a search query
  TEXTBOXINPUT : 63,   // Typing or entering text in the text box
 
 
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Authentication [100-119]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  SIGNIN : 100,       // User sign-in
  SIGNOUT : 101,        // User sign-out
 
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Registration, Contact [160-179]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  REGISTRATIONINITIATE : 161,  // Initiating a registration process
  REGISTRATIONCOMPLETE : 162,  // Completing a registration process
  CANCELSUBSCRIPTION : 163,    // Canceling a subscription
  RENEWSUBSCRIPTION : 164,     // Renewing a subscription
  CHANGESUBSCRIPTION : 165,     // Changing a subscription
  REGISTRATIONCHECKPOINT : 166 // Reaching the registration page/for
  
};

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  dataTags : {
    customDataPrefix : 'data-custom-',
    aiBlobAttributeTag : 'customblob',
    parentDataTag : 'parent-group',
    donotTrackDataTag : 'dnt',
    captureAllMetaDataContent : true,
    useDefaultContentNameOrId : true
  },
  behaviorValidator : BehaviorMapValidator(behaviorMap),
  defaultRightClickBhvr: 'rc'
}; 

const { APP_INSIGHTS_CONNECTION_STRING } = constants;
const browserHistory = createBrowserHistory({ basename: '' });
var reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
  connectionString: APP_INSIGHTS_CONNECTION_STRING,
  extensions: [reactPlugin as any, clickPluginInstance as any],
  extensionConfig: {
    [reactPlugin.identifier]: { history: browserHistory },  
    [clickPluginInstance.identifier]: clickPluginConfig
  }
  }
}); 

const AddAppInsightEvent = (eventData: any, userId: string) => {
  appInsights.trackEvent(eventData);
  appInsights.setAuthenticatedUserContext(userId, undefined, true);
};

const setAppInsightsAuthenticatedUser = (userId: string) => {
  appInsights.setAuthenticatedUserContext(userId, undefined, true);
};

appInsights.loadAppInsights();

export { appInsights, AddAppInsightEvent, setAppInsightsAuthenticatedUser };

// Make jQuery and notifier global
declare global {
  interface Window {
    jQuery: any,
    $: any,
    jquery: any,
    notifier: any,
    store: any,
  }
}

window.jQuery = window.jquery = window.$ = $;
window.notifier = notifier;

// Verify Stored access_token at app startup
// TODO: Re-enable when checkMe endpoint is live
// store.dispatch<any>(loginWithStoredToken());

// Debug store values
if (process.env.NODE_ENV === 'development') {
  window.store = store;
} else {
  // Initialize sentry error tracking
  // Sentry.init({
  //   dsn: "https://d707e95e7f4047119004c50c9d603c25@o1317525.ingest.sentry.io/6570661",
  //   integrations: [new BrowserTracing()],

  //   // Set tracesSampleRate to 1.0 to capture 100%
  //   // of transactions for performance monitoring.
  //   // We recommend adjusting this value in production
  //   tracesSampleRate: 1.0,
  // });
}

// import reportWebVitals from './reportWebVitals';


ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ScrollToTop>

        <Route component={App} />

      </ScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();